import { buttonClasses } from './ui/Button'

interface CsvButtonProps {
  href: string
  label: string
}

/** Download-link stylet som en ghost sm-knap. API'et sætter download-headers, cookien følger med som til et almindeligt link. */
function CsvButton({ href, label }: CsvButtonProps) {
  return (
    <a href={href} download className={buttonClasses({ variant: 'ghost', size: 'sm' })}>
      {label}
    </a>
  )
}

export default CsvButton
